import React, { ReactElement } from 'react';
import { connect } from 'react-redux';
import { State } from '../data/rootReducer';
import { Clearance } from '../data/sessionSlice';
import { AppConnectedProps } from '../data/store';

import './UserRoleProtected.scss';

const connector = connect((state: State) => ({ session: state.session }));

interface UserRoleProtectedProps extends AppConnectedProps<typeof connector> {
  clearance: Clearance;
  protectedStyle: 'none' | 'unlaunched';
  fallback?: JSX.Element;
  children: any; // XXX
}

class UserRoleProtected extends React.Component<UserRoleProtectedProps> {
  render() {
    return this.props.session.clearances.includes(this.props.clearance)
      ? this.renderChildren()
      : this.props.fallback ?? '';
  }

  private renderChildren() {
    if (this.props.protectedStyle === 'none') {
      return this.props.children;
    }
    return React.Children.map(this.props.children, (child: ReactElement, index: number) => {
      if (!child.props) {
        return child;
      }
      return React.cloneElement(child, {
        key: child.key ?? index,
        className: this.addClassName(child.props.className),
      });
    });
  }

  private addClassName(className?: string): string {
    className = className ?? '';
    switch (this.props.protectedStyle) {
      case 'none':
        return className;
      case 'unlaunched':
        return className + ' unlaunched';
      default:
        throw new Error('bad protectedStyle ' + this.props.protectedStyle);
    }
  }
}

export default connector(UserRoleProtected);
